import React, {
    useMemo,
} from 'react'
import {HighlightProps} from './types'
import HighlightRegExp from 'utils/HighlightRegExp'
import HighlightView from './HighlightView'
import {useAppSelector} from 'hooks'


const getHighlights = (highlightSettings: string | string[], highlightName: boolean | undefined, userName: string | undefined): string[] => {
    const highlights = new Set([...highlightSettings, ...[...highlightName && userName ? [userName] : []]])

    return [...highlights]
}
const Highlight: React.FC<HighlightProps> = (props: HighlightProps): React.ReactElement => {
    const {
        children: highlightString, linkTarget, isChatMessage,
    } = props

    const highlightSettings = useAppSelector(({ninchat}) => ninchat.user_settings.highlight) ?? []
    const highlightName = useAppSelector(({ninchat}) => ninchat.user_settings.highlight_name)
    const userName = useAppSelector(({ninchat}) => ninchat.user_attrs.name)

    const highlights = getHighlights(highlightSettings, highlightName, userName)

    const hre = useMemo(() => new HighlightRegExp(highlights, 'giu'), [highlights])

    const blockPattern = /:\/\/|@|['"`]/u

    const isHighlighting = hre.test(highlightString)
    const blockHighlight = isHighlighting && !!highlightString.match(blockPattern)

    const currentHightlightString = blockHighlight ? highlightString : highlightString.replace(hre, '***$&***')

    return (
        <HighlightView
            blockHighlight={blockHighlight}
            highlightString={currentHightlightString}
            isChatMessage={isChatMessage}
            linkTarget={linkTarget}
        />
    )
}

export default Highlight
